import { apiUrl } from "./config";

export const assetCdnBaseUrl = "https://assets.sunnytseng.com";

const getAssetErrorMessage = (data, fallback) => {
  if (!data) return fallback;
  if (typeof data === "string") return data;
  return data.error || data.detail || fallback;
};

export const getAssetPublicUrl = (key) =>
  `${assetCdnBaseUrl}/${String(key || "").split("/").map((part) =>
    encodeURIComponent(part).replace(/[!'()*]/g, (character) =>
      `%${character.charCodeAt(0).toString(16).toUpperCase()}`),
  ).join("/")}`;

export const uploadHandoutFigure = async ({ file, authToken }) => {
  if (!authToken) return { success: false, error: "請先登入。" };
  const body = new FormData();
  body.append("file", file);
  body.append("key", `好題蒐集/${crypto.randomUUID()}.png`);
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 90000);
  try {
    const response = await fetch(`${apiUrl}/assets/upload/`, {
      method: "POST", headers: { Authorization: `Bearer ${authToken}` }, body,
      signal: controller.signal,
    });
    const result = await response.json();
    if (!response.ok || !result?.success || !result.key) {
      throw new Error(getAssetErrorMessage(result, "附圖上傳失敗"));
    }
    return { success: true, key: result.key, url: getAssetPublicUrl(result.key) };
  } catch (error) {
    return { success: false, error: error.name === "AbortError" ? "上傳逾時，請稍後確認素材清單。" : error.message };
  } finally { clearTimeout(timer); }
};

export const listAssets = async ({ authToken, prefix = "", all = true } = {}) => {
  if (!authToken) {
    return { success: false, error: "User not authenticated", files: [] };
  }

  const params = new URLSearchParams();
  if (prefix) params.set("prefix", prefix);
  if (all) params.set("all", "true");

  try {
    const response = await fetch(`${apiUrl}/assets/list/?${params}`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    const result = await response.json().catch(() => null);

    if (!response.ok || !result?.success) {
      return {
        success: false,
        error: getAssetErrorMessage(result, "讀取素材清單失敗"),
        status: response.status,
        files: [],
      };
    }

    const files = result.files || result.objects || [];
    return {
      success: true,
      prefix: result.prefix || prefix,
      files,
      count: result.count ?? files.length,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || "無法連線至素材服務",
      status: 0,
      files: [],
    };
  }
};
